import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import { canViewDashboardTnp } from "./access";

// Wrapper que embute o dashboard estático servido em /public/dashboard.
// O código do dashboard (HTML/CSS/JS) permanece 100% isolado — aqui há apenas
// o <iframe> e o gating de acesso por time (id_cliente === 146).
const DashboardTnp = () => {
  const navigate = useNavigate();
  const autorizado = canViewDashboardTnp();

  useEffect(() => {
    if (!autorizado) {
      // Bloqueio de rota: quem não é do time TNP é redirecionado, mesmo
      // que tente acessar a URL diretamente.
      navigate(all_routes.leadsDashboard, { replace: true });
    }
  }, [autorizado, navigate]);

  // Evita o "flash" do iframe para usuários não autorizados antes do redirect.
  if (!autorizado) return null;

  return (
    <div className="page-wrapper">
      <div className="content p-0">
        <iframe
          title="Monitoramento"
          src={`${process.env.PUBLIC_URL || ""}/dashboard/index.html`}
          style={{
            width: "100%",
            height: "calc(100vh - 60px)",
            border: "none",
            display: "block",
          }}
        />
      </div>
    </div>
  );
};

export default DashboardTnp;
